/* eslint-disable complexity */
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React, { PureComponent } from 'react';
import combineStyles from '../../../../helpers/combineStyles';
import { history } from '../../../../helpers/history';
import ButtonStyles from '../../../../styles/button';
import collapseWrapperStyles from '../../../../styles/components/collapseWrapper';
import SpacingStyles from '../../../../styles/helpers/spacing';
import LayoutStyles from '../../../../styles/layout';
import TypographyStyles from '../../../../styles/typography';
import PrimaryButton from '../../../shared/Buttons/PrimaryButton';
import CollapseWrapper from '../../../shared/CollapseWrapper.js';
import ConfirmDialog from '../../../shared/Modals/ConfirmDialog';
import DocumentItem from './Item';
import FilePicker from '../../../shared/Inputs/FilePicker.js';
const adblockDetector = require('adblock-detect');

const styles = theme => ({
  activityLogButton: {
    marginBottom: 0,
    marginTop: theme.spacing.unit * 2
  }
});

class RenderDocumentItems extends PureComponent {
  renderSaleVouchers(vouchers, saleType) {
    return vouchers.map((item, index) => (
      <DocumentItem
        key={index}
        name={`${
          saleType === 0 ? 'Fact. venta tradicional' : 'Factura de venta'
        } ${index + 1}`}
        url={item}
        loading={false}
      />
    ));
  }

  renderSaleOwnershipCard(documents) {
    return documents.map((item, index) => (
      <DocumentItem
        key={index}
        name={documents.length === 1 ? 'Tarjeta de Propiedad' : `Tarjeta de Propiedad ${index + 1}`}
        url={item}
        loading={false}
      />
    ));
  }

  renderCardifDocuments() {
    const {
      canGenLayerOneRequestPDF,
      canGenLayerTwoRequestPDF,
      requestCardifUrl,
      requestCardifUrlLayerTwoUrl,
      voluntaryInsuranceLayerTwoName,
      salesDetailId,
      pdfRequestCardif,
      pdfRequestCardifLayerTwo
    } = this.props;

    return (
      <>
        {canGenLayerOneRequestPDF && (
          <DocumentItem
            name="Seguro cardif"
            loading={requestCardifUrl}
            fetchDocument={() => pdfRequestCardif(salesDetailId)}
          />
        )}
        {canGenLayerTwoRequestPDF && (
          <DocumentItem
            name={voluntaryInsuranceLayerTwoName}
            loading={requestCardifUrlLayerTwoUrl}
            fetchDocument={() => pdfRequestCardifLayerTwo(salesDetailId)}
          />
        )}
      </>
    );
  }

  render() {
    const {
      canGenBinPDF,
      requestBinUrl,
      canGenPromissoryPDF,
      requestPromissoryUrl,
      canGenVoucherPDF,
      requestVoucherUrl,
      canGenAmortizationPDF,
      requestAmortizationUrl,
      canGenSecurePDF,
      requestSecureUrl,
      saleVouchers,
      saleVehicleOwnershipCard,
      saleType,
      salesDetailId,
      pdfPromissory,
      pdfVoucher,
      pdfAmortization,
      pdfSecure,
      pdfBin,
      canGeneratePledgePDF,
      requestPledgeUrl,
      pdfPledge
    } = this.props;

    return (
      <>
        {canGenBinPDF && (
          <DocumentItem
            name="BIN"
            loading={requestBinUrl}
            fetchDocument={() => pdfBin(salesDetailId)}
          />
        )}
        {canGenPromissoryPDF && (
          <DocumentItem
            name="Pagaré"
            loading={requestPromissoryUrl}
            fetchDocument={() => pdfPromissory(salesDetailId)}
          />
        )}
        {canGenVoucherPDF && (
          <DocumentItem
            name="Voucher"
            loading={requestVoucherUrl}
            fetchDocument={() => pdfVoucher(salesDetailId)}
          />
        )}
        {canGenAmortizationPDF && (
          <DocumentItem
            name="Amortización"
            loading={requestAmortizationUrl}
            fetchDocument={() => pdfAmortization(salesDetailId)}
          />
        )}
        {canGenSecurePDF && (
          <DocumentItem
            name="Fianza"
            loading={requestSecureUrl}
            fetchDocument={() => pdfSecure(salesDetailId)}
          />
        )}
        {canGeneratePledgePDF && (
          <DocumentItem
            name="Pignoración"
            loading={requestPledgeUrl}
            fetchDocument={() => pdfPledge(salesDetailId)}
          />
        )}
        {this.renderSaleVouchers(saleVouchers, saleType)}
        {this.renderSaleOwnershipCard(saleVehicleOwnershipCard)}
        {this.renderCardifDocuments()}
      </>
    );
  }
}

export class Document extends PureComponent {
  state = { dialogAdBlock: false };

  componentDidMount() {
    adblockDetector(adBlockDetected => {
      if (adBlockDetected) this.setState({ dialogAdBlock: true });
    });
  }

  handleCloseDialog = () => this.setState({ dialogAdBlock: false });

  captureVoucher = () => {
    const { salesDetail } = this.props;
    if (salesDetail) {
      history.push(`/digital-sale/capture-voucher/${salesDetail.id}`);
    }
  };

  render() {
    const {
      classes,
      salesDetail,
      canReattachVoucherOnRemoteSale,
      hasCardifArticleLayerOne,
      hasCardifArticleLayerTwo,
      canAttachDocumentsOnTraditionalSale,
      canAttachDocumentsForDocRevisions,
      secureSaleArticleId,
      pledgeArticleId,
      canGenPromissoryPDF,
      canGenVoucherPDF,
      requestPledgeUrl,
      canGenAmortizationPDF,
      requestBinUrl,
      requestPromissoryUrl,
      requestVoucherUrl,
      requestAmortizationUrl,
      requestSecureUrl,
      requestCardifUrl,
      requestCardifUrlLayerTwoUrl,
      voluntaryInsuranceLayerTwoName,
      motorbikeCategoryId,
      pdfRequestCardif,
      pdfRequestCardifLayerTwo,
      pdfBin,
      pdfPromissory,
      pdfVoucher,
      pdfAmortization,
      pdfSecure,
      addVehicleOwnershipCard,
      digitalSaleVoucherStep,
      newAlert,
      loading,
    } = this.props;

    const {
      saleType,
      saleStatus,
      missSaleVoucher,
      saleVouchers,
      externalCode,
      saleDetails,
      documentalRevision
    } = salesDetail;
    const isTraditionalSale = saleType === 0;
    const isRemoteSale = saleType === 1;
    const saleHasSecureArticle = saleDetails.some(
      sd => sd.article.id === secureSaleArticleId
    );
    const saleHasMoto = saleDetails.some(
      sd => sd.article.categoryId === motorbikeCategoryId
    );
    const isSecureSale = saleHasSecureArticle && isTraditionalSale;

    const saleHasPledge = saleDetails.some(
      sd => sd.article.id === pledgeArticleId
    );
    const isActiveSale = !['Devuelta', 'Anulada'].includes(saleStatus);
    const saleHasVouchers = saleVouchers.length > 0;
    const canAttachVoucherToRemoteSale = missSaleVoucher;

    const canAttachInTraditionalSale =
      isTraditionalSale &&
      canAttachDocumentsOnTraditionalSale &&
      (!saleHasVouchers || (saleHasVouchers && canReattachVoucherOnRemoteSale));
    const canAttachInRemoteSale =
      isRemoteSale &&
      canAttachVoucherToRemoteSale &&
      (!saleHasVouchers || (saleHasVouchers && canReattachVoucherOnRemoteSale));
    const canAttachDocumentsForRevision =
      canAttachDocumentsForDocRevisions &&
      (!documentalRevision || documentalRevision.status === 2);

    const canAttachVoucher =
      isActiveSale &&
      externalCode &&
      (canAttachInTraditionalSale ||
        canAttachInRemoteSale ||
        canAttachDocumentsForRevision);

    const canAttachVehicleOwnershipCard = this.props.canAttachVehicleOwnershipCard && (salesDetail.saleVehicleOwnershipCard.length === 0 || (!documentalRevision || documentalRevision.status === 2));
    const canReattachVehicleOwnershipCard = this.props.canReattachVehicleOwnershipCard && salesDetail.saleVehicleOwnershipCard.length !== 0;

    const canGenBinPDF =
      this.props.canGenInvoicePDF &&
      salesDetail.supplier &&
      salesDetail.supplier.requiresBin;
    const canGenSecurePDF = this.props.canGenSecurePDF && isSecureSale;

    const canGenLayerOneRequestPDF =
      this.props.canGenEnsuranceRequestPDF &&
      hasCardifArticleLayerOne &&
      salesDetail.saleType === 0;
    const canGenLayerTwoRequestPDF =
      this.props.canGenEnsuranceRequestPDF &&
      hasCardifArticleLayerTwo &&
      salesDetail.saleType === 0;

    return (
      <CollapseWrapper
        classes={{
          root: classes.root,
          header: classes.panelHeader,
          expandButton: classes.expandButton,
          bodyRoot: classes.collapsePanelBodyRoot
        }}
        header={() => (
          <div className={classes.titleWrapper}>
            <h2 className={classnames(classes.headline8, classes.title)}>
              Documentos
            </h2>
          </div>
        )}
        body={
          <>
            <Divider />
            <div className={classes.body}>
              <RenderDocumentItems
                canGenBinPDF={canGenBinPDF}
                canGenPromissoryPDF={canGenPromissoryPDF}
                canGenVoucherPDF={canGenVoucherPDF}
                canGenAmortizationPDF={canGenAmortizationPDF}
                canGenSecurePDF={canGenSecurePDF}
                requestBinUrl={requestBinUrl}
                requestPromissoryUrl={requestPromissoryUrl}
                requestVoucherUrl={requestVoucherUrl}
                requestAmortizationUrl={requestAmortizationUrl}
                requestSecureUrl={requestSecureUrl}
                canGenLayerOneRequestPDF={canGenLayerOneRequestPDF}
                canGenLayerTwoRequestPDF={canGenLayerTwoRequestPDF}
                requestCardifUrl={requestCardifUrl}
                requestCardifUrlLayerTwoUrl={requestCardifUrlLayerTwoUrl}
                voluntaryInsuranceLayerTwoName={voluntaryInsuranceLayerTwoName}
                saleVouchers={salesDetail.saleVouchers}
                saleVehicleOwnershipCard={salesDetail.saleVehicleOwnershipCard}
                saleType={salesDetail.saleType}
                salesDetailId={salesDetail.id}
                pdfRequestCardif={pdfRequestCardif}
                pdfRequestCardifLayerTwo={pdfRequestCardifLayerTwo}
                pdfBin={pdfBin}
                pdfPromissory={pdfPromissory}
                pdfVoucher={pdfVoucher}
                pdfAmortization={pdfAmortization}
                pdfSecure={pdfSecure}
                salesDetail={salesDetail}
                secureSaleArticleId={this.props.secureSaleArticleId}
                pledgeArticleId={this.props.pledgeArticleId}
                pdfPledge={this.props.pdfPledge}
                pledgeUrl={this.props.pledgeUrl}
                canGeneratePledgePDF={
                  saleHasPledge && this.props.canGeneratePledgePDF
                }
                requestPledgeUrl={requestPledgeUrl}
              />

              {canAttachVoucher && (
                <FilePicker
                  multiple
                  acceptExtensions={[".pdf", ".png", ".jpg", ".jpeg"]}
                  onError={errMsg => newAlert('error', 'ERROR:', errMsg)}
                  onFilesSelected={(files) => {
                    const extensions = files.map(file => file.name.split('.').pop());
                    digitalSaleVoucherStep({
                      saleId: salesDetail.id,
                      files,
                      isExternal: false,
                      extensions,
                    });
                  }}
                >
                  <PrimaryButton
                    variant="contained"
                    className={classes.button}
                    loading={loading}
                  >
                    Adjuntar Factura
                  </PrimaryButton>
                </FilePicker>
              )}
              {isActiveSale && externalCode && saleHasMoto && (canAttachVehicleOwnershipCard || canReattachVehicleOwnershipCard) && (
                <FilePicker
                  multiple
                  acceptExtensions={[".pdf", ".png", ".jpg", ".jpeg"]}
                  onError={errMsg => newAlert('error', 'ERROR:', errMsg)}
                  onFilesSelected={(files) => {
                    const extensions = files.map(file => file.name.split('.').pop());
                    addVehicleOwnershipCard({ saleId: salesDetail.id, files, extensions }, window.location);
                  }}
                >
                  <PrimaryButton
                    variant="contained"
                    className={classnames(classes.button, classes.vehicleButton)}
                    loading={loading}
                  >
                    Adjuntar tarjeta de propiedad
                  </PrimaryButton>
                </FilePicker>
              )}
            </div>
            <ConfirmDialog
              open={this.state.dialogAdBlock}
              title="Bloqueador de ventanas emergentes detectado"
              text="Recuerda desactivarlo para poder visualizar los documentos."
              buttonTextConfirm="ok"
              onConfirm={this.handleCloseDialog}
              onClose={this.handleCloseDialog}
            />
          </>
        }
      />
    );
  }
}

export default withStyles(
  combineStyles(
    SpacingStyles,
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    styles,
    collapseWrapperStyles
  )
)(Document);
